/**
 * @author 冷 (https://github.com/LengYXin)
 * @email lengyingxin8966@gmail.com
 * @create date 2021-08-16 18:31:46
 * @modify date 2021-08-16 18:31:46
 * @desc [description]
 */
import LoadingComponent from '@/components/loading';
import Cookies from 'js-cookie';
import lodash from 'lodash';
import React, { $Store } from 'react';
import { forkJoin, lastValueFrom } from 'rxjs';
import { dynamic } from 'umi';
import { latag, link } from './extension';
import { $AppConfig } from './global';
import { Static } from './static';
lodash.update(
  React,
  'lazy',
  lodash.constant((loader) => dynamic({ loader, loading: LoadingComponent })),
);
Object.defineProperty(React.Component.prototype, '$Static', {
  get: lodash.constant(Static),
});
Object.defineProperty(React.Component.prototype, '$LoginOut', {
  get: lodash.constant(async (allowLidLoginout?) => {
    window.sessionStorage.setItem('_account_loginOut', 'true'); //退出登录，供lenovoid单点登录使用
    const isLidLogin = $Store.UserInfo.User.isLidLogin;
    await lastValueFrom(
      forkJoin([$Store.System.onLoginOut(), $AppConfig.onClear()]),
    );
    if (allowLidLoginout && isLidLogin) {
      window.location.href = $Store.Lenovoid.createLidLoginoutUrl(true);
      return;
    }
  }),
});
Object.defineProperty(React.Component.prototype, '$SetCookie', {
  get: lodash.constant((key, value) => {
    ['localhost', '127.0.0.1', '.lenovo.com', '.lenovo.com.cn'].map(
      (domain) => {
        Cookies.set(key, value, {
          domain: domain,
          expires: $Store.System.AutoLogin ? 7 : 1,
        });
      },
    );
  }),
});
Object.defineProperty(React.Component.prototype, '$SetUserCookie', {
  get: lodash.constant(() => {
    // if ($Store.System.AccessToken) {
    //   ['localhost', '127.0.0.1', '.lenovo.com', '.lenovo.com.cn'].map(
    //     (domain) => {
    //       Cookies.set('usertokenUrl', $Store.System.AccessToken, {
    //         domain: domain,
    //         expires: $Store.System.AutoLogin ? 7 : 1,
    //         secure: true,
    //         sameSite: 'Lax',
    //       });
    //       Cookies.set('usernameUrl', $Store.UserInfo.username, {
    //         domain: domain,
    //         expires: $Store.System.AutoLogin ? 7 : 1,
    //       });
    //     },
    //   );
    // }
  }),
});
Object.defineProperty(React.Component.prototype, '$ClearUserCookie', {
  get: lodash.constant(() => {
    const domian = ['localhost', '127.0.0.1'].includes(window.location.hostname)
      ? window.location.hostname
      : '.lenovo.com';
    // Cookies.remove('token')
    Cookies.remove('usertokenUrl', {
      domain: domian,
    });
    Cookies.remove('usernameUrl', {
      domain: domian,
    });
  }),
});

Object.defineProperty(React.Component.prototype, '$HandleQuery', {
  get: lodash.constant(async (type, query?) => {
    if (lodash.eq(type, 'set')) {
      // window.sessionStorage.setItem('_account_query', JSON.stringify(query));
      await $AppConfig.localforage.setItem(
        '_account_query',
        JSON.stringify(query),
      );
      return;
    }
    if (lodash.eq(type, 'get')) {
      // $Store.UserInfo.query = JSON.parse( window.sessionStorage.getItem('_account_query') );
      let query: string = await $AppConfig.localforage.getItem(
        '_account_query',
      );
      $Store.UserInfo.query = JSON.parse(query);
      return;
    }

    if (lodash.eq(type, 'remove')) {
      // window.sessionStorage.removeItem('_account_query');
      await $AppConfig.localforage.removeItem('_account_query');
      return;
    }
  }),
});

// 页面跳转
Object.defineProperty(React.Component.prototype, '$windowOpen', {
  get: lodash.constant((url) => {
    if ($AppConfig.userAgent.isiOS) {
      location.href = url;
    } else {
      window.open(url);
    }
  }),
});
// 获取高德定位信息
Object.defineProperty(React.Component.prototype, '$GetAmap', {
  get: lodash.constant(function () {
    return new Promise<any>((res, rej) => {
      function resolveAddress() {
        if (lodash.get(React, '_address')) {
          console.warn('LENG ~ 高德定位', lodash.get(React, '_address'));
          res(lodash.get(React, '_address'));
        }
      }
      if (lodash.get(React, '_address')) {
        resolveAddress();
      } else {
        let map = null;
        const jsapi = document.createElement('script');
        jsapi.async = true;
        // @ts-ignore
        window._AMapSecurityConfig = {
          // securityJsCode: $AppConfig.amapSecurityKey,
          serviceHost: `${$AppConfig.target}/_AMapService`,
        };
        // jsapi.src = `https://webapi.amap.com/maps?v=1.4.15&key=${$AppConfig.amapKey}`;
        jsapi.src = `${$AppConfig.target}/amap-script?v=1.4.15`;
        jsapi.addEventListener('load', (event) => {
          // @ts-ignore
          map = new AMap.Map('');
          map.plugin('AMap.Geolocation', () => {
            // @ts-ignore
            const geolocation = new AMap.Geolocation({
              enableHighAccuracy: true, //是否使用高精度定位，默认:true
              timeout: 2000, //超过2秒后停止定位，默认：无穷大
              maximumAge: 0, //定位结果缓存0毫秒，默认：0
              convert: true, //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
              showButton: true, //显示定位按钮，默认：true
              buttonPosition: 'LB', //定位按钮停靠位置，默认：'LB'，左下角
              // @ts-ignore
              buttonOffset: new AMap.Pixel(10, 20), //定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
              showMarker: true, //定位成功后在定位到的位置显示点标记，默认：true
              showCircle: true, //定位成功后用圆圈表示定位精度范围，默认：true
              panToLocation: true, //定位成功后将定位到的位置作为地图中心点，默认：true
              zoomToAccuracy: true, //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
            });
            map.addControl(geolocation);
            geolocation.getCurrentPosition();
            // @ts-ignore
            AMap.event.addListener(geolocation, 'complete', (data) => {
              if (lodash.has(data, 'addressComponent')) {
                // 解析设置 code
                const adcode = lodash.get(data, 'addressComponent.adcode');
                const province = lodash.get(data, 'addressComponent.province');
                const city =
                  lodash.get(data, 'addressComponent.city') || province;
                const district = lodash.get(data, 'addressComponent.district');
                const provinceCode = lodash.toInteger(
                  lodash.fill(lodash.toArray(adcode), 0, 2).join(''),
                );
                const cityCode = lodash.toInteger(
                  lodash.fill(lodash.toArray(adcode), 0, 4).join(''),
                );
                const _address = [
                  { label: province, value: provinceCode },
                  { label: city, value: cityCode },
                  { label: district, value: lodash.toInteger(adcode) },
                ];
                lodash.set(
                  React,
                  '_address',
                  lodash.merge(data, {
                    _address,
                  }),
                );
                resolveAddress();
              }
              rej();
            });
            // @ts-ignore
            AMap.event.addListener(geolocation, 'error', rej);
          });
        });
        document.head.appendChild(jsapi);
      }
    });
  }),
});

Object.defineProperty(React.Component.prototype, '$Link', {
  get: lodash.constant(link),
});
Object.defineProperty(React.Component.prototype, '$Latag', {
  get: lodash.constant(latag),
});
declare module 'react' {
  interface Component {
    /** 静态资源 */
    readonly $Static: typeof Static;
    /** 外部链接 */
    readonly $Link: typeof link;
    /** 创建埋点 */
    readonly $Latag: typeof latag;
    /** 设置用户cookie信息 */
    $SetUserCookie: () => any;
    /** 清除用户cookie信息 */
    $ClearUserCookie: () => any;
    /** 设置cookie信息 */
    $SetCookie: (key: any, value: any) => any;
    /** 高德定位 */
    $GetAmap: () => Promise<any>;
    /** 登出清除所有信息 */
    $LoginOut: (allowLidLoginout?) => Promise<any>;
    /** oauth处理query */
    $HandleQuery: (type: string, query?: any) => any;
    readonly $windowOpen: (url: string) => any;
  }
  interface HTMLAttributes<T> {
    /** 埋点标记 */
    latag?: string;
  }
}
